<template>
  <fieldset class="form__row-fieldset col-12 col-xl-7">
    <legend class="sr-only">{{ label }}</legend>
    <div class="row row--gap-0">
      <div class="col-4 col-xl" v-for="(option, index) in options" :key="option.day">
        <div class="radio-btn radio-btn--negative"
              :class="{'radio-btn--disabled': disabled}">
          <label :for="id + '-' + inputId + '-' + index" class="radio-btn__label">
            <span class="radio-btn__label-headline">{{ disabled ? 'DD.MM.' : option.day }}</span>
            <span class="radio-btn__label-text">{{ disabled ? '' : option.label }}</span>
          </label>
          <input class="radio-btn__input"
                 type="radio"
                 :id="id + '-' + inputId + '-' + index"
                 :name="name"
                 :value="option.day"
                 :checked="modelValue === option.day"
                 @change="handleChange(option.day)"
                 :disabled="disabled"
                 :aria-invalid="hasError"
                 :tabindex="disabled ? -1 : ''"
                 :aria-describedby="hasError ? 'error-' + id + '-' + inputId : null">
        </div>
      </div>
      <div class="col-12 col-xl" v-if="hasError">
        <Error v-if="hasError"
               :id="'error-' + id + '-' + inputId"
               :message="errorMessage" />
      </div>
    </div>
  </fieldset>
</template>
<script setup>
import Error from '../fields/Error.vue';
import { ref, computed, watch, useId } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  modelValue: {
    type: [String, Number, Boolean, null],
    default: null,
  },
  options: {
    type: Array,
    required: true
  },
  rules: {
    type: Array,
    default: () => [],
  },
  forceValidation: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['update:modelValue', 'validation-change']);

const internalValue = ref(props.modelValue);
const isTouched = ref(false);
const errorMessage = ref('');
const inputId = useId();

watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});

watch(() => props.options, (n) => {
  validate();
});

const validate = () => {
  if(!props.disabled) {
    for (const rule of props.rules) {
      const result = rule(internalValue.value);
      if (typeof result === 'string') {
        errorMessage.value = result;
        emit('validation-change', false);
        return false;
      }
    }
    errorMessage.value = '';
    emit('validation-change', true);
    return true;
  }
};

watch([internalValue, () => props.forceValidation, isTouched], () => {
  if (isTouched.value || props.forceValidation) {
    validate();
  } else {
    errorMessage.value = '';
  }
}, { immediate: true });

const handleChange = (selectedValue) => {
  internalValue.value = selectedValue;
  emit('update:modelValue', internalValue.value);
  isTouched.value = true;
};

const hasError = computed(() => (isTouched.value || props.forceValidation) && errorMessage.value !== '');
</script>